import {
	Eye,
	Layout,
	BookOpen,
	Contrast,
	Pause,
	Focus,
	Link2,
	LinkIcon,
	Languages,
	Search,
	Move,
	PanelLeftClose,
	Zap,
	EyeOff,
	Brain,
	Keyboard,
	Text,
	Scaling,
	Baseline,
	ZoomIn,
	Bold,
	BookA,
	ALargeSmall,
	BetweenHorizontalStart,
	Space,
	AlignLeft,
	Palette,
	Droplet,
	Mic,
	ScreenShare,
	VenetianMaskIcon as Mask,
	Compass,
	ImageOff,
	Hand,
	MessageSquare,
	TextCursorIcon as Cursor,
	DropletOff,
	LucideLayoutPanelTop,
	MousePointer2,
	Cast,
	Scan,
	CirclePause,
	ArrowUpToLine,
	SquareMousePointer,
	MessageSquareMore,
	Sparkles,
	Highlighter,
	Image,
	MousePointerClick,
} from "lucide-react";
import { isPremiumFeature } from "./premium-features";

export const DEFAULT_FEATURES = [
	// {
	// 	title: "Accessibility Features Profile",
	// 	infoTooltip: "Adjust features for different accessibility profiles.",
	// 	settings: [
	// 		{ label: "Seizure Safe Profile", key: "seizureSafeProfile", icon: Zap },
	// 		{
	// 			label: "Vision Impaired Profile",
	// 			key: "visionImpairedProfile",
	// 			icon: EyeOff,
	// 		},
	// 		{
	// 			label: "ADHD Friendly Profile",
	// 			key: "adhdFriendlyProfile",
	// 			icon: Brain,
	// 		},
	// 		{
	// 			label: "Cognitive Disability Profile",
	// 			key: "cognitiveDisabilityProfile",
	// 			icon: Brain,
	// 		},
	// 		{
	// 			label: "Keyboard Navigation (Motor)",
	// 			key: "keyboardNavigationMotor",
	// 			icon: Keyboard,
	// 		},
	// 		{
	// 			label: "Blind Users (Screen Reader)",
	// 			key: "blindUsersScreenReader",
	// 			icon: BookOpen,
	// 		},
	// 		{ label: "Dyslexia", key: "dyslexia", icon: Text },
	// 	],
	// },
	{
		title: "Content Adjustments",
		infoTooltip: "Adjust how content is displayed.",
		settings: [
			{ label: "Content Scaling", key: "contentScaling", icon: Scaling },
			{ label: "Readable Font", key: "readableFont", icon: Bold },
			{ label: "Dyslexia Friendly", key: "dyslexiaFriendly", icon: Text },
			{ label: "Highlight Titles", key: "highlightTitles", icon: Baseline },
			{ label: "Highlight Links", key: "highlightLinks", icon: Link2 },
			{ label: "Bigger Text", key: "adjustFontSizing", icon: ALargeSmall },
			{
				label: "Line Height",
				key: "adjustLineHeight",
				icon: BetweenHorizontalStart,
			},
			{
				label: "Letter Spacing",
				key: "adjustLetterSpacing",
				icon: Space,
			},
			{
				label: "Text Alignment",
				key: "contentAlignment",
				icon: AlignLeft,
			},
			{ label: "Dictionary", key: "dictionary", icon: BookA },
		],
	},
	{
		title: "Color Adjustments",
		infoTooltip: "Modify color schemes for better readability.",
		settings: [
			{ label: "Greyscale", key: "greyscale", icon: DropletOff },
			{ label: "Contrast", key: "contrast", icon: Contrast },
			{ label: "Color Saturation", key: "colorSaturation", icon: Droplet },
		],
	},
	{
		title: "Navigation Adjustments",
		infoTooltip: "Settings for navigation methods.",
		settings: [
			{
				label: "Page Structure",
				key: "pageStructure",
				icon: LucideLayoutPanelTop,
			},

			{ label: "Big Cursor", key: "bigCursor", icon: MousePointer2 },
			{
				label: "Pointer Trail",
				key: "pointerTrail",
				icon: Highlighter,
				enabled: true,
			},
			{ label: "Click Spark", key: "clickSpark", icon: MousePointerClick },
			{ label: "Image Trails", key: "imageTrails", icon: Image },
		],
	},
	{
		title: "Orientation Adjustments",
		infoTooltip: "Adjust screen orientation and reading aids.",
		settings: [
			{ label: "Screen reader", key: "screenReader", icon: Cast },
			{ label: "Reading mask", key: "readingMask", icon: Scan },
			{ label: "Pause animations", key: "pauseAnimations", icon: CirclePause },
			{ label: "Reading Guide", key: "readingGuide", icon: ArrowUpToLine },
			{ label: "Hide images", key: "hideImages", icon: ImageOff },
			{ label: "Outline focus", key: "outlineFocus", icon: Focus },
			{
				label: "Highlight Hover",
				key: "highlightHover",
				icon: SquareMousePointer,
			},
			{ label: "Magnify Images", key: "magnifiImages", icon: ZoomIn },
			{ label: "Tooltips", key: "tooltips", icon: MessageSquareMore },
		],
	},
];
export function enrichFeatures(remoteFeatures = []) {
	const flatRemoteMap = Object.fromEntries(
		remoteFeatures.flatMap((cat) =>
			cat.settings.map((setting) => [setting.key, setting]),
		),
	);

	return DEFAULT_FEATURES.map((category) => ({
		...category,
		settings: category.settings.map((setting) => {
			const remote = flatRemoteMap[setting.key] || {};
			const isPremium = isPremiumFeature(setting.key);

			// Default enabled state: premium features off, others on
			const defaultEnabled = !isPremium;

			return {
				...setting,
				enabled: remote.enabled ?? setting.enabled ?? defaultEnabled,
				premium: isPremium,
			};
		}),
	}));
}
